document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('#main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open', !expanded);
    });
    nav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', 'false'); nav.classList.remove('is-open');
    }));
  }

  // Also localize preferences links added later by the consent banner.
  const footer = document.querySelector('.site-footer');
  if (footer) {
    function localizeCookieLinks() {
      footer.querySelectorAll('a, button').forEach(link => {
        if (link.textContent.trim().toLowerCase() !== 'cookie preferences') return;
        link.textContent = 'Cookie-Einstellungen';
        if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', 'Cookie-Einstellungen');
        if (link.hasAttribute('title')) link.setAttribute('title', 'Cookie-Einstellungen');
      });
    }
    localizeCookieLinks();
    new MutationObserver(localizeCookieLinks).observe(footer, { childList: true, characterData: true, subtree: true });
  }

  const motifGrid = document.querySelector('[data-motif-grid]');
  const browseToolbar = document.querySelector('[data-browse-toolbar]');
  if (motifGrid && browseToolbar) {
    let cards = [...motifGrid.querySelectorAll('.art-card')];
    const gridButton = browseToolbar.querySelector('[data-browse-grid]');
    const swipeButton = browseToolbar.querySelector('[data-browse-swipe]');
    const controls = browseToolbar.querySelector('[data-browse-controls]');
    const prevButton = browseToolbar.querySelector('[data-browse-prev]');
    const nextButton = browseToolbar.querySelector('[data-browse-next]');
    const counter = browseToolbar.querySelector('[data-browse-counter]');
    const nextPageLink = document.querySelector('[data-browse-next-page]');
    let currentIndex = 0;
    let scrollFrame = 0;

    // Progressive collection loading: retain native pagination as a fallback
    // until JavaScript has successfully initialized the infinite gallery.
    const pagination = document.querySelector('.collection-page .pagination');
    const infiniteStatus = document.querySelector('[data-infinite-status]');
    const infiniteSentinel = document.querySelector('[data-infinite-sentinel]');
    let nextCollectionUrl = nextPageLink ? nextPageLink.href : null;
    let loadingCollection = false;
    let infiniteObserver = null;
    const loadedCollectionUrls = new Set([window.location.href]);

    function showNativePagination() {
      if (pagination) pagination.hidden = false;
      if (infiniteObserver) infiniteObserver.disconnect();
    }

    async function loadNextCollectionPage() {
      if (loadingCollection || !nextCollectionUrl) return;
      loadingCollection = true;
      if (infiniteStatus) infiniteStatus.hidden = false;
      const requestUrl = new URL(nextCollectionUrl, window.location.href);
      requestUrl.hash = '';
      try {
        if (loadedCollectionUrls.has(requestUrl.href)) {
          throw new Error('Repeated pagination URL');
        }
        const response = await fetch(requestUrl.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection pagination request failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const pageGrid = page.querySelector('[data-motif-grid]');
        if (!pageGrid) throw new Error('Collection products not found');
        const newCards = [...pageGrid.querySelectorAll('.art-card')];
        if (!newCards.length) throw new Error('No products on next page');
        const seenIds = new Set(cards.map(card => card.dataset.productId).filter(Boolean));
        const fragment = document.createDocumentFragment();
        const appended = [];
        for (const card of newCards) {
          const id = card.dataset.productId;
          if (id && seenIds.has(id)) continue;
          if (id) seenIds.add(id);
          const fresh = document.importNode(card, true);
          fragment.appendChild(fresh);
          appended.push(fresh);
        }
        if (!appended.length) throw new Error('No new products on next page');
        motifGrid.appendChild(fragment);
        cards.push(...appended);
        loadedCollectionUrls.add(requestUrl.href);
        const followLink = page.querySelector('[data-browse-next-page]');
        nextCollectionUrl = followLink ? new URL(followLink.getAttribute('href'), requestUrl.href).href : null;
        if (nextPageLink) {
          nextPageLink.hidden = true;
          if (nextCollectionUrl) nextPageLink.href = nextCollectionUrl;
        }
        updateBrowsePosition();
        if (!nextCollectionUrl && infiniteObserver) infiniteObserver.disconnect();
      } catch (error) {
        // Keep the next page accessible if the connection or markup fails.
        showNativePagination();
        if (nextPageLink && nextCollectionUrl) {
          nextPageLink.href = nextCollectionUrl;
          nextPageLink.hidden = false;
        }
        nextCollectionUrl = null;
      } finally {
        loadingCollection = false;
        if (infiniteStatus) infiniteStatus.hidden = true;
      }
    }

    if (nextCollectionUrl && infiniteSentinel && 'IntersectionObserver' in window) {
      if (pagination) pagination.hidden = true;
      infiniteObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && !motifGrid.classList.contains('is-browsing')) {
          loadNextCollectionPage();
        }
      }, { rootMargin: '900px 0px', threshold: 0 });
      infiniteObserver.observe(infiniteSentinel);
    }


    function updateBrowsePosition() {
      if (!motifGrid.classList.contains('is-browsing')) return;
      const firstOffset = cards[0].offsetLeft;
      currentIndex = cards.reduce((best, card, index) =>
        Math.abs(card.offsetLeft - firstOffset - motifGrid.scrollLeft) <
        Math.abs(cards[best].offsetLeft - firstOffset - motifGrid.scrollLeft) ? index : best, 0);
      counter.textContent = `${currentIndex + 1} / ${cards.length}`;
      prevButton.disabled = currentIndex === 0;
      nextButton.disabled = currentIndex === cards.length - 1 && !nextCollectionUrl;
      if (nextCollectionUrl && currentIndex >= cards.length - 4) loadNextCollectionPage();
      if (nextPageLink) nextPageLink.hidden = currentIndex !== cards.length - 1;
    }

    function setBrowseMode(browsing) {
      motifGrid.classList.toggle('is-browsing', browsing);
      gridButton.setAttribute('aria-pressed', String(!browsing));
      swipeButton.setAttribute('aria-pressed', String(browsing));
      controls.hidden = !browsing;
      if (nextPageLink) nextPageLink.hidden = true;
      motifGrid.tabIndex = browsing ? 0 : -1;
      motifGrid.scrollLeft = 0;
      currentIndex = 0;
      if (browsing) requestAnimationFrame(updateBrowsePosition);
      else if (nextCollectionUrl && infiniteSentinel && infiniteSentinel.getBoundingClientRect().top < window.innerHeight + 900) loadNextCollectionPage();
    }

    function browseTo(index) {
      if (index < 0 || index >= cards.length) {
        if (index >= cards.length && nextCollectionUrl) loadNextCollectionPage();
        return;
      }
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      motifGrid.scrollTo({
        left: cards[index].offsetLeft - cards[0].offsetLeft,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    if (cards.length > 1) {
      browseToolbar.hidden = false;
      // Mobile pages start with two columns, including links to later pages.
      // Keep the desktop continuation of the optional browsing view.
      setBrowseMode(!window.matchMedia('(max-width: 800px)').matches && window.location.hash === '#motive-durchblaettern');
      gridButton.addEventListener('click', () => setBrowseMode(false));
      swipeButton.addEventListener('click', () => setBrowseMode(true));
      prevButton.addEventListener('click', () => browseTo(currentIndex - 1));
      nextButton.addEventListener('click', () => browseTo(currentIndex + 1));
      motifGrid.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = 0;
          updateBrowsePosition();
        });
      }, { passive: true });
      motifGrid.addEventListener('keydown', event => {
        if (event.target !== motifGrid || !motifGrid.classList.contains('is-browsing')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          browseTo(currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      window.addEventListener('resize', updateBrowsePosition);
    }
  }

  // A direct product URL has no Shopify collection context. Load only the small
  // navigation section using the same product URL in its chosen collection.
  const directMotifNavigation = document.querySelector('[data-motif-navigation][data-context-url]');
  if (directMotifNavigation) {
    const contextUrl = new URL(directMotifNavigation.dataset.contextUrl, window.location.href);
    contextUrl.searchParams.set('section_id', 'motif-navigation');
    fetch(contextUrl, { credentials: 'same-origin' })
      .then(response => {
        if (!response.ok) throw new Error('Motivnavigation nicht verfügbar');
        return response.text();
      })
      .then(html => {
        const section = new DOMParser().parseFromString(html, 'text/html');
        const navigation = section.querySelector('[data-motif-navigation]');
        if (!navigation) throw new Error('Keine Motive in dieser Kollektion gefunden');
        directMotifNavigation.replaceWith(document.importNode(navigation, true));
      })
      .catch(() => {
        const pending = directMotifNavigation.querySelector('[data-motif-navigation-pending]');
        if (pending) pending.remove();
      });
  }

  const relatedSection = document.querySelector('[data-related-motifs]');
  if (relatedSection) {
    const relatedGrid = relatedSection.querySelector('.related-motifs-grid');
    const relatedBreakpoint = window.matchMedia('(max-width: 800px)');
    const desktopSlot = document.querySelector('[data-related-desktop-slot]');
    const mobileSlot = document.querySelector('[data-related-mobile-slot]');
    let mobileRecommendationsInitialized = false;

    // Move the SINGLE, real recommendations element between its desktop and
    // mobile locations. Avoid duplicate IDs/cards and preserve JS listeners.
    function positionRelatedMotifs() {
      const target = relatedBreakpoint.matches ? mobileSlot : desktopSlot;
      if (target && relatedSection.parentElement !== target) target.appendChild(relatedSection);
    }

    function initMobileRecommendations() {
      if (mobileRecommendationsInitialized) return;
      mobileRecommendationsInitialized = true;
      // Resolve collection URLs from the navigation as a fallback for stores where
      // main_menu is not available to the Liquid section.
      const supplied = (relatedSection.dataset.mobileCollections || '').split('||')
        .filter(Boolean).map(entry => entry.split('::')[0]).filter(Boolean);
      const navLinks = [...document.querySelectorAll('a[href*="/collections/"]')];
      const classify = text => {
        text = String(text || '').toLocaleLowerCase('de-DE');
        if (/frauen|portrait|porträt/.test(text)) return 'women';
        if (/abstrakt/.test(text)) return 'abstract';
        if (/tier/.test(text)) return 'animals';
        return '';
      };
      const matching = {};
      for (const link of navLinks) {
        const path = new URL(link.href, location.href).pathname;
        const kind = classify(link.textContent + ' ' + path);
        if (kind && !matching[kind]) matching[kind] = path;
      }
      for (const path of supplied) {
        const kind = classify(path);
        if (kind) matching[kind] = path;
      }
      const breadcrumb = document.querySelector('.breadcrumbs a[href*="/collections/"]');
      const currentPath = breadcrumb ? new URL(breadcrumb.href, location.href).pathname :
        (relatedSection.dataset.collectionUrl || '');
      const currentKind = classify((breadcrumb ? breadcrumb.textContent : '') + ' ' + currentPath);
      if (currentKind && currentPath) matching[currentKind] = currentPath;
      const order = currentKind === 'abstract' ? ['abstract', 'women', 'animals'] :
        currentKind === 'animals' ? ['animals', 'abstract', 'women'] :
        ['women', 'abstract', 'animals'];
      const categories = [...new Set(order.map(key => matching[key]).filter(Boolean))];
      const seen = new Set([relatedSection.dataset.productId]);
      let categoryIndex = 0;
      let nextPage = 1;
      let busy = false;
      let initialized = false;
      let finished = !categories.length;
      let errors = 0;

      function convertCard(source) {
        const id = source.dataset.productId;
        const link = source.querySelector('.art-card-link');
        const heading = source.querySelector('.art-card-info h3');
        if (!id || !link || !heading || seen.has(id)) return null;
        seen.add(id);
        const card = document.createElement('a');
        card.className = 'related-motif-card';
        card.href = link.href;
        card.dataset.productId = id;
        const name = heading.textContent.trim();
        card.setAttribute('aria-label', `${name} ansehen`);
        const image = document.createElement('span');
        image.className = 'related-motif-image';
        const originalImage = source.querySelector('.card-first-image');
        const imageContainer = source.querySelector('.art-card-image');
        if (imageContainer) {
          for (const attribute of imageContainer.attributes) {
            if (attribute.name.startsWith('data-artwork-')) image.setAttribute(attribute.name, attribute.value);
          }
        }
        if (originalImage) {
          const clone = originalImage.cloneNode(true);
          clone.loading = 'lazy';
          image.append(clone);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'related-motif-placeholder';
          placeholder.textContent = 'Bild folgt';
          image.append(placeholder);
        }
        const title = document.createElement('span');
        title.className = 'related-motif-title';
        title.textContent = name;
        card.append(image, title);
        return card;
      }

      async function loadNextPage() {
        if (!relatedBreakpoint.matches || busy || finished) return;
        busy = true;
        try {
          while (categoryIndex < categories.length) {
            const url = new URL(categories[categoryIndex], location.origin);
            url.searchParams.set('page', String(nextPage));
            // Fetch the normal collection page, not an unreliable 'main' section response.
            const response = await fetch(url.href, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Collection request failed: ' + response.status);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const grid = doc.querySelector('.collection-grid');
            if (!grid) throw new Error('Collection grid missing');
            const sources = [...grid.querySelectorAll('.art-card')];
            const hasNext = !!doc.querySelector('.pagination a[rel="next"], .browse-next-page');
            nextPage++;
            if (!initialized) {
              relatedGrid.replaceChildren();
              initialized = true;
            }
            const cards = sources.map(convertCard).filter(Boolean);
            cards.forEach(card => relatedGrid.append(card));
            if (!hasNext || !sources.length) { categoryIndex++; nextPage = 1; }
            errors = 0;
            if (cards.length) break;
          }
          if (categoryIndex >= categories.length) finished = true;
        } catch (error) {
          // Keep the original 27 items if loading fails, rather than emptying the slider.
          console.warn('Flamingo Royale: Weitere Motive konnten nicht geladen werden.', error);
          if (++errors >= 2) finished = true;
        } finally {
          busy = false;
          maybeLoadMore();
        }
      }

      function maybeLoadMore() {
        if (!relatedBreakpoint.matches || busy || finished) return;
        const bounds = relatedSection.getBoundingClientRect();
        if (bounds.top > innerHeight + 700 || bounds.bottom < -300) return;
        const remaining = relatedGrid.scrollWidth - relatedGrid.clientWidth - relatedGrid.scrollLeft;
        if (!initialized || remaining < relatedGrid.clientWidth * 3) loadNextPage();
      }
      relatedGrid.addEventListener('scroll', maybeLoadMore, { passive: true });
      window.addEventListener('resize', maybeLoadMore, { passive: true });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) maybeLoadMore();
        }, { rootMargin: '650px 0px' });
        observer.observe(relatedSection);
      } else {
        maybeLoadMore();
      }
    }

    positionRelatedMotifs();
    if (relatedBreakpoint.matches) initMobileRecommendations();
    else {
      // Desktop initially shows the first nine suggestions, as before.
      const cards = [...relatedGrid.querySelectorAll('.related-motif-card')];
      cards.slice(9).forEach(card => card.remove());
    }
    const onLayoutChange = () => {
      positionRelatedMotifs();
      if (relatedBreakpoint.matches) initMobileRecommendations();
    };
    if (typeof relatedBreakpoint.addEventListener === 'function')
      relatedBreakpoint.addEventListener('change', onLayoutChange);
    else if (typeof relatedBreakpoint.addListener === 'function')
      relatedBreakpoint.addListener(onLayoutChange);
  }

  const gallery = document.querySelector('.product-media-gallery');
  const galleryItems = gallery ? [...gallery.querySelectorAll('[data-image-variant]')] : [];
  const galleryHint = document.querySelector('[data-gallery-hint]');
  const galleryEmpty = gallery ? gallery.querySelector('[data-gallery-empty]') : null;

  function normalizeVariantTitle(value) {
    return String(value || '').normalize('NFKC').toLowerCase()
      .replace(/[×✕✖＊*]/g, 'x').replace(/\s+/g, '').trim();
  }

  function updateVariantGallery(variantTitle) {
    if (!galleryItems.length) return;
    const selectedTitle = normalizeVariantTitle(variantTitle);
    let visibleCount = 0;
    galleryItems.forEach(item => {
      const taggedVariant = item.dataset.imageVariant;
      // Untagged images are shared; images for other sizes stay hidden.
      item.hidden = Boolean(taggedVariant && normalizeVariantTitle(taggedVariant) !== selectedTitle);
      if (!item.hidden) visibleCount += 1;
    });
    galleryItems.forEach(item => item.classList.remove('is-first-visible'));
    const firstVisible = galleryItems.find(item => !item.hidden);
    if (firstVisible) firstVisible.classList.add('is-first-visible');
    if (galleryHint) galleryHint.hidden = visibleCount < 2;
    if (galleryEmpty) galleryEmpty.hidden = visibleCount !== 0;
    gallery.scrollLeft = 0;
  }

  document.querySelectorAll('[data-variant-select]').forEach(select => {
    select.addEventListener('change', () => {
      const details = select.closest('.product-details');
      const price = details ? details.querySelector('[data-product-price]') : null;
      const variant = select.selectedOptions[0];
      if (price) price.textContent = variant ? variant.dataset.price || '' : '';
      const interestPrice = details ? details.querySelector('[data-interest-price]') : null;
      if (interestPrice) interestPrice.value = variant ? variant.dataset.price || '' : '';
      const selectedFormat = document.querySelector('[data-selected-format]');
      if (selectedFormat) selectedFormat.textContent = variant ? variant.dataset.title || '' : '';
      updateVariantGallery(variant ? variant.dataset.title : '');
    });
    updateVariantGallery(select.selectedOptions[0] ? select.selectedOptions[0].dataset.title : '');
  });

  const lightbox = document.querySelector('[data-image-lightbox]');
  const zoomButtons = [...document.querySelectorAll('[data-zoom-image]')];
  if (lightbox && zoomButtons.length) {
    const display = lightbox.querySelector('[data-lightbox-view]');
    const counter = lightbox.querySelector('[data-lightbox-counter]');
    const prev = lightbox.querySelector('[data-lightbox-prev]');
    const next = lightbox.querySelector('[data-lightbox-next]');
    let currentIndex = 0;

    function visibleZoomButtons() {
      return zoomButtons.filter(button => {
        const item = button.closest('.product-media-item');
        return !item || !item.hidden;
      });
    }

    function showImage(index) {
      const visibleButtons = visibleZoomButtons();
      if (!visibleButtons.length) return;
      currentIndex = (index + visibleButtons.length) % visibleButtons.length;
      const button = visibleButtons[currentIndex];
      display.src = button.dataset.fullSrc;
      display.alt = button.dataset.fullAlt || 'Vergrößertes Produktbild';
      counter.textContent = `${currentIndex + 1} / ${visibleButtons.length}`;
      prev.hidden = next.hidden = visibleButtons.length < 2;
    }

    zoomButtons.forEach(button => button.addEventListener('click', () => {
      showImage(visibleZoomButtons().indexOf(button));
      if (!lightbox.open) {
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
        else {
          lightbox.classList.add('is-legacy-dialog');
          lightbox.setAttribute('open', '');
        }
      }
    }));
    function closeLightbox() {
      if (typeof lightbox.close === 'function') lightbox.close();
      else {
        lightbox.removeAttribute('open');
        display.removeAttribute('src');
      }
    }
    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', closeLightbox);
    prev.addEventListener('click', () => showImage(currentIndex - 1));
    next.addEventListener('click', () => showImage(currentIndex + 1));
    lightbox.addEventListener('click', event => { if (event.target === lightbox) closeLightbox(); });
    lightbox.addEventListener('keydown', event => {
      if (event.key === 'Escape' && typeof lightbox.close !== 'function') closeLightbox();
      if (event.key === 'ArrowLeft') { event.preventDefault(); showImage(currentIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showImage(currentIndex + 1); }
    });
    lightbox.addEventListener('close', () => display.removeAttribute('src'));
  }
});
